import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LoaderSvg from '../../assets/img/dot-revolve.svg';

interface LoaderProps {
  text?: string;
}

function Loader({ text }: LoaderProps) {
  return (
    <Grid display="flex" flexDirection="column" gap={2} alignItems="center" mt={3.5}>
      <Box component="img" src={LoaderSvg} />
      <Typography variant="title2Regular" color="black" textAlign="center">
        {text || 'Gems are lining up...'}
      </Typography>
    </Grid>
  );
}

export default Loader;
